import React = require("react");

export interface ISearchBoxProps {
    query: (query: string) => void; // thunk
}

export const SearchBox = (props: ISearchBoxProps): React.ReactElement<ISearchBoxProps> => {
    return (
        <div className="wpo ui centered borderless panel p-search-center">
            <input type="text" className="wpo ui input very stretched text is-first p-search-input" onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.query(event.target.value) } />
            <button className="wpo ui input stretched button is-last p-search-submit">Search</button>
        </div>
    );
}